import { render, staticRenderFns } from "./GAndACategories.vue?vue&type=template&id=209edd52&"
import script from "./GAndACategories.vue?vue&type=script&lang=js&"
export * from "./GAndACategories.vue?vue&type=script&lang=js&"
import style0 from "./GAndACategories.vue?vue&type=style&index=0&id=209edd52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports